// extracted by mini-css-extract-plugin
export default {"tryhosting":"banner2_tryhosting__7J3bc","back":"banner2_back__Wa66y"};